const SuccessActionType = {
  STORE_SIGNUP_SUCCESS_PLAN: 'SUCCESS_STORE_SIGNUP_SUCCESS_PLAN',
  STORE_SIGNUP_CONTRACT: 'SUCCESS_STORE_SIGNUP_CONTRACT',
  RESET_ALL: 'SUCCESS_RESET_ALL',
  STORE_VALIDATED_PROMO_CODE: 'SUCCESS_STORE_VALIDATED_PROMO_CODE',
  STORE_TRACKING_ID: 'SUCCESS_STORE_TRACKING_ID',
  STORE_PARTNER: 'STORE_PARTNER'
};

export default SuccessActionType;



/** WEBPACK FOOTER **
 ** ./src/common/SuccessActionType.js
 **/